import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../directives/Icon/Icon';
import { BOOKED, CANCEL, PAID, ON_WAY, SUCCESS, RETURNED, CASH_BOOKING } from '../helper';
/**
 * Константа соответствий статусов в которых может прибывать заказ
 */
const STATUSES_INFO = {
  cash_booking: {
    title: I18n.t('components.OrderStatus.booked_cash_booking'),
    icon: 'ico-ok',
    color: 'success'
  },
  booked: {
    title: I18n.t('components.OrderStatus.booked'),
    icon: 'combined-shape-2',
    color: 'error'
  },
  cancel: {
    title: I18n.t('components.OrderStatus.cancel'),
    icon: 'ico-fail',
    color: 'error'
  },
  paid: {
    title: I18n.t('components.OrderStatus.paid'),
    icon: 'combined-shape-1',
    color: 'success'
  },
  on_way: {
    title: I18n.t('components.OrderStatus.on_way'),
    icon: 'combined-shape-1',
    color: 'success'
  },
  success: {
    title: I18n.t('components.OrderStatus.success'),
    icon: 'ico-ok',
    color: 'success'
  },
  returned: {
    title: I18n.t('components.OrderStatus.returned'),
    icon: 'ico-fail',
    color: 'error'
  }
};
const OrderStatus = ({
  status = ''
}) => {
  const {
    title
  } = STATUSES_INFO[status];
  const {
    icon
  } = STATUSES_INFO[status];
  const {
    color
  } = STATUSES_INFO[status];
  return [/*#__PURE__*/React.createElement("div", {
    key: "icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    color: color
  })), /*#__PURE__*/React.createElement("div", {
    key: "title"
  }, title)];
};
OrderStatus.propTypes = {
  status: PropTypes.oneOf([BOOKED, CANCEL, PAID, ON_WAY, SUCCESS, RETURNED, CASH_BOOKING])
};
export default OrderStatus;